<template>
  <div class="news-content-container" :style="containerStyle">
    <div class="news-content-inner">
      <div class="title-box" :style="{color: eleConfig.otherConfig.titleColor || '#333'}">{{ $dt(eleConfig, 'title') }}</div>
      <!--      {{eleConfig.gap}}-->
      <a-row :gutter="[eleConfig.gap || 24, eleConfig.gap || 24]">
        <a-col v-for="item in eleConfig.dataList" :key="item._id" :span="24/(eleConfig.otherConfig.columnCount || 3)">
          <div :style="itemStyle">
            <img class="news-image" :style="{height: getNumber(eleConfig.otherConfig.imageHeight, 260) + 'px'}" :src="getImagePath(item)" />
            <div class="news-title" :style="{color: eleConfig.otherConfig.newsTitleColor || '#333'}">{{ $dt(item, 'title') }}</div>
            <div class="news-content" :style="{color: eleConfig.otherConfig.newsContentColor || '#333'}">{{ $dt(item, 'content') }}</div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import componentMixin from './componentMixin';

export default {
  name: "likeNews",
  mixins: [componentMixin],
  computed: {
    containerStyle() {
      const style = {};
      style.backgroundColor = this.eleConfig.backgroundColor || '#ffffff';
      return style;
    },
    itemStyle() {
      const style = { height: '100%' };
      const otherConfig = this.eleConfig.otherConfig;
      style.padding = this.getNumber(otherConfig.newsPadding, 24) + 'px';
      style.borderRadius = this.getNumber(otherConfig.newsBorderRadius, 0) + 'px';
      style.backgroundColor = otherConfig.newsBackgroundColor || '#FFFFFF';
      return style;
    },
  },
  methods: {},
}
</script>

<style scoped lang="scss">
.news-content-container {
  width: 100%;
  padding: 96px 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .news-content-inner {
    width: 1280px;
    margin: 0 auto;
  }

  .title-box {
    font-size: 32px;
    line-height: 45px;
    font-weight: 600;
    margin-bottom: 24px;
  }

  .news-image {
    height: 260px;
    width: 100%;
    object-fit: cover;
    margin-bottom: 24px;
  }

  .news-title {
    font-size: 24px;
    line-height: 33px;
    font-weight: 600;
  }

  .news-content {
    line-height: 20px;
  }
}

</style>
